module.exports = __webpack_public_path__ + "img/vehicle.be0dcc44.jpg";